import { useMemo } from 'react'
import { useValueEditor, } from 'react-querybuilder'
import {
    InputFieldColumn,
} from '../InputField'
import { BaseSelect } from '../../../../select/ReportSelect'

const JoinColumnsValueEditor = props => {
    const disabled = props.context && props.context.viewOnly
    const {
        className,
        fieldData: { dataSourceColumns, selectedDataSources, table1Identifier, table1TableName: table1, table2 },
        validation,
    } = props

    const { valueAsArray, multiValueHandler } = useValueEditor(props)

    const column1Options = useMemo(() => 
        dataSourceColumns.filter(x => x.TABLE_NAME === table1),
        [dataSourceColumns, table1]
    )
    
    const column2Options = useMemo(() => 
        dataSourceColumns.filter(x => x.TABLE_NAME === table2),
        [dataSourceColumns, table2]
    )

    const editors = [column1Options, column2Options].map((options, i) => {
        const defaultVal = options.find(x => x.value === valueAsArray[i]) || ''
        let disabledField = false
        if (i === 0) {
            disabledField = table1 === null || table1 === undefined || table1 === ''
        } else if (i === 1) {
            disabledField = table2 === null || table2 === undefined || table2 === ''
        }

        let validatorResult = {
            valid: true,
            reasons: {},
        }
        if (validation && !validation.valid) {
            validatorResult = { field: { message: validation.reasons[i] } }
        }

        return (
            <div
                className={className}
                style={{
                    ...props.style,
                    width: '100%',
                    // minWidth: (props.style && props.style.width) || `calc(${biggestOptionCharacterLength}ch + 25px)`
                }}
                title={defaultVal.value}
            >
                <InputFieldColumn
                    name={`field`} // no errors for this input type
                    fieldErrors={validatorResult}
                    isClearable={false}
                >
                    <BaseSelect
                        className={props.className}
                        options={options}
                        isClearable={false}
                        isDisabled={disabled || disabledField}
                        value={defaultVal}
                        onChange={selectedValue => {
                            multiValueHandler(selectedValue.value, i)
                            return selectedValue
                        }}
                    />
                </InputFieldColumn>
            </div>
        )
    })

    return (
        <>
            {editors[0]}
            {editors[1]}
        </>
    )
    // return (
    //         <div
    //             style={{ width: '25%' }}
    //             // title={ruleTitle}
    //         >
    //             <InputFieldColumn
    //                 name={`field`} // no errors for this input type
    //                 // fieldErrors={validatorResult}
    //                 isClearable={false}
    //             >
    //                 <BaseSelect
    //                     // key={`${key}.${i}`}
    //                     defaultValue={yesNoOptions01.find(
    //                         v => v.value === rule.value
    //                     )}
    //                     onChange={option => {
    //                         handleOnChange(option.value)
    //                         return option
    //                     }}
    //                     className={className}
    //                     disabled={disabled}
    //                     options={yesNoOptions01}
    //                     isClearable={false}
    //                 />
    //         </div>
    // )
}

export default JoinColumnsValueEditor
